import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SidebarService } from '../sidebar/sidebar.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  id = [0, 1, 2, 3, 4, 5];

  izborPrikaza = [
    'Časovni poteki' ,
    'Srednje spremembe z zanesljivostjo',
    'Razponi sprememb',
    'Trendi z zanesljivostjo',
    'Povprečni razponi sprememb po regijah/postajah',
    'Preglednice'
  ];

  constructor(public router: Router,
              private sidebar: SidebarService) { }

  toggleActive: boolean = false;

  drawerToggle() {
    this.toggleActive = !this.toggleActive;
    this.sidebar.toggle();

  }

  ngOnInit() {
  }

}
